// eslint-disable-next-line no-unused-vars
import React, { ReactNode } from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

export type BreakpointProps = {
  className?: string
  innerStyles?: Object
  children: ReactNode
}

const Breakpoint: React.FC<BreakpointProps> = ({ className, innerStyles, children }) => (
  <Outer className={classNames('px-breakpoint', 'breakpoint', className)}>
    <Inner className={classNames('px-breakpoint-inner', 'breakpoint-inner')} style={innerStyles}>
      {children}
    </Inner>
  </Outer>
)

export default Breakpoint

const Outer = styled.div`
  margin: 0 auto;
  position: relative;
  padding: 0 18px;

  @media screen and (min-width: 1080px) {
    width: 1080px;
  }

  @media screen and (min-width: 990px) and (max-width: 1079px) {
    width: 990px;
  }

  @media screen and (min-width: 900px) and (max-width: 989px) {
    width: 900px;
  }

  @media screen and (min-width: 810px) and (max-width: 899px) {
    width: 810px;
  }

  @media screen and (min-width: 720px) and (max-width: 799px) {
    width: 720px;
  }

  @media screen and (min-width: 630px) and (max-width: 719px) {
    width: 630px;
  }

  @media screen and (min-width: 576px) and (max-width: 639px) {
    width: 576px;
  }

  @media screen and (max-width: 575px) {
    width: 100%;
  }
`

const Inner = styled.div`
  position: relative;
  height: 100%;
`
